const ca = {
  code: 'ca',
  name: 'Canada',
  flag: '🇨🇦',
  localTips: [
    'CRA and immigration scam calls often threaten arrest or deportation to create panic.',
    'Interac e-Transfer and crypto payment requests from unknown callers are red flags.',
  ],
  resources: [
    {
      title: 'Canadian Anti-Fraud Centre',
      description: 'Report fraud and learn about current scams in Canada.',
      url: 'https://antifraudcentre-centreantifraude.ca/',
    },
    {
      title: 'RCMP Scams and Fraud',
      description: 'Information on recognizing and reporting fraud.',
      url: 'https://www.rcmp-grc.gc.ca/en/scams-frauds',
    },
  ],
};

export default ca;
